import Vue from 'vue'
import Vuex from 'vuex'
import { dictionariesModule } from './dictionariesModule'
import { selectionModule } from './selectionModule'
import { guestsModule } from './guestsModule'
import { loyaltyModule } from './loyaltyModule'
import { extraServicesModule } from './extraServicesModule'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    // bookingId: null,
    bookingStep: 1,
    isStepThreeSingleton: 0,
    isLoading: false,

    // bonusPrograms: [], // формируется на основе запроса


    // data: { // в модалке
    //   type: '',
    //   value: '',
    //   sum: '',
    // },

    // // обратно
    // data: {
    //   // сумма баллов на счету
    //   // макс для списания за раз
    //   // код для дальнейших операций
    // },

    // // применение бонусов
    // data: {
    //   code: 0, // кроме 0 - ошибка
    //   value: 6666 // сумма списания
    // },
  }),

  getters: {
    getIsPresent: (state, getters) => {
      return state.isPresent
    },
    getFullTotalPrice: (state, getters, rootState, rootGetters) => {
      let totalPrice = 0
      let guestsPrice = getters['guestsModule/getTotalPrice']
      let extraServicesPrice = getters['extraServices/getTotalPrice']

      totalPrice += +guestsPrice
      totalPrice += +extraServicesPrice

      return totalPrice
    },

    getTotalPrice: (state, getters, rootState, rootGetters) => {
      let totalPrice = getters.getFullTotalPrice
      let loyaltyPoints = getters['loyalty/getPointsToWriteOff']

      totalPrice -= +loyaltyPoints

      return totalPrice
    },

    getPriceForUDS: (state, getters) => {
      let totalPrice = getters['guestsModule/getTotalPrice'] || 0
      let extraServices = state.dictionaries.extraServices
      let guestsHealthcardPrices = getters['guestsModule/getFilteredGuestsFields'](
        [ 'gender', 'guestType' ],
        { 'healthcard': true },
      ).forEach(guest => {
        let healthcardId = null

        if(guest.guestType === '0') {
          if(guest.gender === 'male') {
            healthcardId = 1650 // мужская санкур карта
          } else if (guest.gender === 'female') {
            healthcardId = 1648 // детская санкур карта
          }
        } else if (guest.guestType === '1') {
          healthcardId = 1651 // детская санкур карта
        }

        if(healthcardId) {
          totalPrice -= +extraServices.find((el) => el.id === healthcardId).price || 0
        }
      })

      // console.log(guestsHealthcardPrices)

      return totalPrice
    },
  },

  mutations: {
    setBookingId(state, id) {
      state.bookingId = id
    },

    setIsLoading(state, bool) {
      state.isLoading = bool
    },

    setStep(state, val) {
      state.bookingStep = val
    },

    setIsStepThreeSingleton(state, value) {
      state.isStepThreeSingleton = value
    },

    setBonusPrograms(state, payload) {
      for(let name in payload) {
        if(payload[name]) {
          let tmp = {
            id: name,
            isSelected: false
          }

          if(name === 'uds') Object.assign(tmp, {
            isApplied: false,
            value: 0,
            direction: null
          })

          state.bonusPrograms.push(tmp)

        }
      }
    },

    updateBonusProgram(state, payload) {
      Object.assign(
        state.bonusPrograms.find(obj => obj.id === payload.id),
        payload.data,
      )
    }
  },

  actions: {
    changeStep({state, commit, dispatch}, val) {
      commit('setStep', +val)
      // dispatch('checkGuestsComplete')
    },

    changeIsStepThreeSingleton({commit}, payload) {
      commit('setIsStepThreeSingleton', payload)
    },

    updateBonusProgram({commit}, payload) {
      commit('updateBonusProgram', payload)
    }
  },

  modules: {
    dictionaries: dictionariesModule,
    selection: selectionModule,
    // accommodationVariants: accomodationVariantsModule,
    // bookingForm: bookingFormModule,
    guestsModule: guestsModule,
    extraServices: extraServicesModule,
    loyalty: loyaltyModule,
  }
})
